import { defineMessages } from 'react-intl';

export default defineMessages({
  rachatsEncours: {
    id: 'releve_situation.rachats_encours',
  },
  rachatsEncoursDescription: {
    id: 'releve_situation_rachats.description',
  },
  avanceEncours: {
    id: 'releve_situation.avances_encours',
  },
  avanceEncoursDescription: {
    id: 'releve_situation.avances.description',
  },
});
